module.exports = __webpack_public_path__ + "img/no-appointments.dbe69987.svg";